import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation, Pagination } from "swiper/modules";

SwiperCore.use([Navigation, Pagination]);
const ConditionalWrapper = ({ condition, wrapper, children }) =>
  children ? (condition ? wrapper(children) : children) : null;

export const ConditionalSwiper = (props) => {
  const { condition, children } = props;

  // console.debug("props", props);
  return (
    <ConditionalWrapper
      condition={condition}
      wrapper={(children) => (
        <Swiper
          slidesPerView={props.slidesPerView}
          spaceBetween={props.spaceBetween}
          centeredSlides={props.centeredSlides}
          navigation={props.navigation}
          pagination={props.pagination}
          direction={props.direction}
          autoplay={props.autoplay}
          speed={props.speed}
          loop={props.loop}
          onSlideChange={props.onSlideChange}
          className={props.className}
        >
          {children?.map((item, id) => (
            <SwiperSlide key={id}>{item}</SwiperSlide>
          ))}
        </Swiper>
      )}
    >
      {children}
    </ConditionalWrapper>
  );
};

ConditionalSwiper.defaultProps = {
  navigation: false,
  pagination: false,
  autoplay: false,
  loop: false,
  direction: "horizontal",
  onSlideChange: () => {},
  speed: 1000
};
